<template>
  <div class="care-plan-item-container">
    <h4 v-if="headerToken" class="treatment-group-header mb-2 font-semibold">
      <mrx-translation :token="headerToken"></mrx-translation>
    </h4>
    <v-layout column>
      <div
          v-for="(contentItem, index) in contentList"
          :key="`${contentItem.name}_${contentItem.headerToken}`"
      >
        <care-plan-row
            :contentItem="contentItem"
            :isChecklist="isChecklist"
            :isLast="index === contentList.length - 1"
            :disabledItems="disabledItems"
            :checkboxIcon="checkboxIcon(contentItem.name)"
            @select="select"
        />
      </div>
    </v-layout>
  </div>

</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import icons from "@/mixins/icons"
import ui from "@/mixins/ui"
import MrxTranslation from "@/components/thinkmd/mrx/translation.vue";
import CarePlanRow from "@/features/overall-assessment/components/care-plan/CarePlanRow.vue";
import type { DisabledItemsMap, FollowUpContentItem } from "@/features/overall-assessment/types/overall-assessment.types";

export default defineComponent({
  name: "CarePlanItem",
  components: {CarePlanRow, MrxTranslation},
  mixins: [icons, ui],
  props: {
    headerToken: String,
    headerIcon: String,
    headerIconColor: String,
    contentList: { type: Array as PropType<FollowUpContentItem[]>, default: () => [] },
    isChecklist: {type: Boolean, default: false},
    isExpandable: {type: Boolean, default: false},
    defaultExpanded: {type: Boolean, default: true},
    value: { type: Array as PropType<string[]>, default: () => [] },
    disabledItems: {type: Object as PropType<DisabledItemsMap>, default: () => ({})}
  },
  data() {
    return {
      selected: [...this.value],
    };
  },
  watch: {
    value() {
      this.selected = this.value
    }
  },
  methods: {
    itemIsSelected(name: string) {
      return this.selected.includes(name)
    },
    select(name: string) {
      if (this.isChecklist && !this.disabledItems[name]) {
        if (this.itemIsSelected(name)) {
          this.selected = this.selected.filter(selected => selected !== name)
        } else {
          this.selected.push(name)
        }
        this.$emit('handleInput', this.selected)
      }
    },
    checkboxIcon(name: string) {
      if (this.itemIsSelected(name)) {
        return this.icons.mdiCheckboxOutline
      } else {
        return this.icons.mdiCheckboxBlankOutline
      }
    }
  },
});
</script>
